import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiPlay, FiTv, FiChevronRight, FiInfo } from 'react-icons/fi';
import './TV.css';

const TV = () => {
  const [shows, setShows] = useState([]);
  const [featuredShow, setFeaturedShow] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  useEffect(() => {
    loadTVContent();
  }, []);

  const loadTVContent = async () => {
    try {
      const res = await fetch('http://localhost:5000/api/tv');
      const data = await res.json();
      setShows(data.shows || []);
      setFeaturedShow(data.featured || null);
      setCategories(data.categories || []);
    } catch (error) {
      console.error('Error loading TV content:', error);
      setShows([]);
      setFeaturedShow(null);
      setCategories(['Todos']);
    } finally {
      setLoading(false);
    }
  };

  const filteredShows = selectedCategory === 'Todos' 
    ? shows 
    : shows.filter(show => show.category === selectedCategory);

  const slugify = (text) => {
    if (!text) return '';
    return text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  };

  const getShowSlug = (show) => {
    if (show?.slug) return show.slug;
    return slugify(show?.title) || 'programa';
  };

  const getFirstEpisodeSlug = (show) => {
    if (show?.first_episode_slug) return show.first_episode_slug;
    // Fallback for hero only; backend resolves by T/E numbers.
    return 't1-e1';
  };

  if (loading) {
    return (
      <div className="tv-loading">
        <div className="tv-icon-loading">
          <FiTv />
        </div>
        <p>Sintonizando...</p>
      </div>
    );
  }

  return (
    <div className="tv-page">
      {/* Hero con programa destacado */}
      {featuredShow && (
        <section className="tv-hero">
          <div className="hero-background">
            <img src={featuredShow.banner_image || featuredShow.cover_image} alt="" />
            <div className="hero-gradient"></div>
          </div>
          
          <div className="hero-content">
            <div className="tv-logo">
              <FiTv className="tv-icon" />
              <span>GRAPHYRA TV</span>
            </div>
            
            <span className="featured-label">DESTACADO</span>
            <h1>{featuredShow.title}</h1>
            <p>{featuredShow.description}</p>
            
            <div className="hero-meta">
              <span className="meta-item">
                {featuredShow.total_seasons || 1} {(featuredShow.total_seasons || 1) === 1 ? 'temporada' : 'temporadas'}
              </span>
              <span className="meta-item">
                {featuredShow.episodes_count} episodios
              </span>
              <span className="category-tag">{featuredShow.category}</span>
            </div>
            
            <div className="hero-actions">
              <Link to={`/tv/watch/${getShowSlug(featuredShow)}/${getFirstEpisodeSlug(featuredShow)}`} className="btn-watch">
                <FiPlay /> Ver ahora
              </Link>
              <Link to={`/tv/show/${getShowSlug(featuredShow)}`} className="btn-info">
                <FiInfo /> Más información
              </Link>
            </div>
          </div>
          
          {/* Efecto TV retro */}
          <div className="tv-scanlines"></div>
        </section>
      )}

      {/* Categorías */}
      <section className="tv-categories">
        <div className="categories-wrapper">
          {categories.map(category => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </section>

      {/* Grid de programas */}
      <section className="tv-shows">
        <div className="section-header">
          <h2>
            {selectedCategory === 'Todos' ? 'Todos los programas' : selectedCategory}
          </h2>
          <span className="shows-count">{filteredShows.length} programas</span>
        </div>
        
        <div className="shows-grid">
          {filteredShows.map(show => (
            <Link key={show.id} to={`/tv/show/${getShowSlug(show)}`} className="show-card">
              <div className="show-thumbnail">
                <img src={show.cover_image} alt={show.title} />
                <div className="play-overlay">
                  <div className="play-button">
                    <FiPlay />
                  </div>
                </div>
                <span className="episode-count">
                  {show.total_seasons > 1 
                    ? `${show.total_seasons} Temp` 
                    : `${show.episodes_count} EP`
                  }
                </span>
              </div>
              <div className="show-info">
                <h3>{show.title}</h3>
                <p>{show.description}</p>
                <div className="show-meta">
                  <span className="show-category">{show.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Continuar viendo (placeholder) */}
      <section className="tv-continue">
        <div className="section-header">
          <h2>🎬 Continuar viendo</h2>
          <Link to="/tv/history" className="see-all">
            Ver historial <FiChevronRight />
          </Link>
        </div>
        
        <div className="continue-message">
          <p>Inicia sesión para guardar tu progreso y continuar donde lo dejaste</p>
          <Link to="/login" className="btn-login">Iniciar sesión</Link>
        </div>
      </section>

      
    </div>
  );
};

export default TV;
